import React, { Component } from "react";
import RugAPI from "../../api/rug";
import RoomRugFilterBrands from "./filters/roomRugFilterBrands";
import RoomRugFilterShanehs from "./filters/roomRugFilterShanehs";
import RoomRugFilterDensities from "./filters/roomRugFilterDensities";
import RoomRugFilterYarns from "./filters/roomRugFilterYarns";
import RoomRugMobileFilterSizes from "./filters/mobile/sizes";
import RecommendedRugs from "./recommendedRugs";
import RoomRugFilterMobileBrands from "./filters/mobile/brands";
import RoomRugFilterMobileShanehs from "./filters/mobile/shanehs";
import RoomRugFilterMobileDensities from "./filters/mobile/densities";
import RoomRugFilterMobileYarns from "./filters/mobile/yarns";
import RoomRugFilterSizes from "./filters/roomRugFilterSizes";

export default class RoomRugFilter extends Component {
  state = {
    mobileActive: false,
    activeFilter: "brands",

    // Brands
    rugBrands: [],
    rugBrandsLoading: true,

    // Yarns
    rugYarns: [],
    rugYarnsLoading: true,
  };

  loadBrands = () => {
    const api = new RugAPI();
    api.getRugBrands().then((response) => {
      this.setState({ rugBrandsLoading: false });
      if (response.success) {
        this.setState({ rugBrands: response.data });
      }
    });
  };

  loadYarns = () => {
    const api = new RugAPI();
    api.getRugYarns().then((response) => {
      this.setState({ rugYarnsLoading: false });
      if (response.success) {
        this.setState({ rugYarns: response.data });
      }
    });
  };

  componentDidMount() {
    this.loadBrands();
    this.loadYarns();
  }

  handleScroll = () => {
    const slider = document.getElementById("ulSlider");
    if (slider.scrollLeft < 600) {
      this.props.itemsScrollHandler();
    }
  };

  handleManualScroll = (direction) => {
    switch (direction) {
      case "right":
        document.getElementById("ulSlider").scrollLeft -= 120;
        break;
      default:
        document.getElementById("ulSlider").scrollLeft += 120;
        break;
    }

    this.handleScroll();
  };

  getActiveFilterComponent = (activeFilter) => {
    switch (activeFilter) {
      case "brands":
        return (
          <RoomRugFilterBrands
            brands={this.state.rugBrands}
            selectedBrands={this.props.filters.selectedBrands}
            selectHandler={this.props.selectHandler}
            activeFilter={this.state.activeFilter}
			loading={this.state.rugBrandsLoading}
			texts={this.props.texts}
          />
        );
      case "shanehs":
        return (
          <RoomRugFilterShanehs
            selectedShanehs={this.props.filters.selectedShanehs}
            selectHandler={this.props.selectHandler}
			activeFilter={this.state.activeFilter}
			texts={this.props.texts}
          />
        );
      case "densities":
        return (
          <RoomRugFilterDensities
            selectedDensities={this.props.filters.selectedDensities}
            selectHandler={this.props.selectHandler}
			activeFilter={this.state.activeFilter}
			texts={this.props.texts}
          />
        );
      case "yarns":
        return (
          <RoomRugFilterYarns
            yarns={this.state.rugYarns}
            selectedYarns={this.props.filters.selectedYarns}
            selectHandler={this.props.selectHandler}
            activeFilter={this.state.activeFilter}
			loading={this.state.rugYarnsLoading}
			texts={this.props.texts}
          />
        );

      default:
        break;
    }
  };

  filterChangeHandler = (filter, mobile = false) => {
    if (filter !== this.state.activeFilter) {
      this.setState({ activeFilter: filter });
    }
  };

  render() {
    return (
      <>
        <div
          className={`mobile-menu ${this.state.mobileActive ? "active" : ""}`}
        >
          <button
            className="w-100 carpet-btn active"
            onClick={() =>
              this.setState({ mobileActive: !this.state.mobileActive })
            }
          >
            فرش
          </button>
          <div className="d-flex">
            <div className="carpet-body">
              <RecommendedRugs
                rugs={this.props.rugs}
                loading={this.props.rugsLoading}
                selectedIds={this.props.selectedIds}
                activeId={this.props.activeId}
                selectHandler={this.props.rugSelectHandler}
                getRugComponent={this.props.getRugComponent}
                hasNext={this.props.rugsHasNext}
                loadRugs={this.props.loadRugs}
                filters={this.props.rugFilters}
				compType={"mobile"}
              />
            </div>
            <div className="list-body">
              <ul className="pt-4">
                <li
                  className={`first-child ${
                    this.state.activeFilter === "sizes" ? "active" : ""
                  }`}
                >
                  <span
                    onClick={() => this.setState({ activeFilter: "sizes" })}
                  >
                     اندازه{" "}
                  </span>
                  <i className="arrow" />

                  {this.state.activeFilter === "sizes" && (
                    <RoomRugMobileFilterSizes texts={this.props.texts} />
                  )}
                </li>
                <li
                  className={`first-child ${
                    this.state.activeFilter === "brands" ? "active" : ""
                  }`}
                >
                  <span
                    onClick={() => this.setState({ activeFilter: "brands" })}
                  >
                     {this.props.texts["brand"]}{" "}
                  </span>
                  <i className="arrow" />
                  {this.state.activeFilter === "brands" && (
                    <RoomRugFilterMobileBrands
                      brands={this.state.rugBrands}
                      selectedBrands={this.props.filters.selectedBrands}
                      selectHandler={this.props.selectHandler}
                      activeFilter={this.state.activeFilter}
					  loading={this.state.rugBrandsLoading}
                    />
                  )}
                </li>
                <li
                  className={`first-child ${
                    this.state.activeFilter === "shanehs" ? "active" : ""
                  }`}
                >
                  <span
                    onClick={() => this.setState({ activeFilter: "shanehs" })}
                  >
                     {this.props.texts["shaneh"]}{" "}
                  </span>
                  <i className="arrow" />
                  {this.state.activeFilter === "shanehs" && (
                    <RoomRugFilterMobileShanehs
                      selectedShanehs={this.props.filters.selectedShanehs}
                      selectHandler={this.props.selectHandler}
					  activeFilter={this.state.activeFilter}
                    />
                  )}
                </li>
                <li
                  className={`first-child ${
                    this.state.activeFilter === "densities" ? "active" : ""
                  }`}
                >
                  <span
                    onClick={() => this.setState({ activeFilter: "densities" })}
                  >
                     {this.props.texts["density"]}{" "}
                  </span>
                  <i className="arrow" />
                  {this.state.activeFilter === "densities" && (
                    <RoomRugFilterMobileDensities
                      selectedDensities={this.props.filters.selectedDensities}
                      selectHandler={this.props.selectHandler}
					  activeFilter={this.state.activeFilter}
                    />
                  )}
                </li>
                <li
                  className={`first-child ${
                    this.state.activeFilter === "yarns" ? "active" : ""
                  }`}
                >
                  <span
                    onClick={() => this.setState({ activeFilter: "yarns" })}
                  >
                     {this.props.texts["yarn"]}{" "}
                  </span>
                  <i className="arrow" />
                  {this.state.activeFilter === "yarns" && (
                    <RoomRugFilterMobileYarns
                      yarns={this.state.rugYarns}
                      selectedYarns={this.props.filters.selectedYarns}
                      selectHandler={this.props.selectHandler}
                      activeFilter={this.state.activeFilter}
					  loading={this.state.rugYarnsLoading}
                    />
                  )}
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="navbar active">
          <ul className="nav-ul">
            <button onClick={this.props.addRugHandler}>
              <img src="/static/img/plus24.png" alt="button-icon" />
            </button>
            <li
              className={this.state.activeFilter === "brands" ? "active" : ""}
              onClick={() => this.filterChangeHandler("brands")}
            >
              {this.props.texts["brand"]}{" "}
              <span>
                <i className="arrow" />
              </span>{" "}
            </li>
            <li
              onClick={() => this.filterChangeHandler("shanehs")}
              className={this.state.activeFilter === "shanehs" ? "active" : ""}
            >
              {this.props.texts["shaneh"]}{" "}
              <span>
                <i className="arrow" />
              </span>{" "}
            </li>
            <li
              onClick={() => this.filterChangeHandler("densities")}
              className={
                this.state.activeFilter === "densities" ? "active" : ""
              }
            >
              {this.props.texts["density"]}{" "}
              <span>
                <i className="arrow" />
              </span>{" "}
            </li>
            <li
              onClick={() => this.filterChangeHandler("yarns")}
              className={this.state.activeFilter === "yarns" ? "active" : ""}
            >
              {this.props.texts["yarn"]}{" "}
              <span>
                <i className="arrow" />
              </span>{" "}
            </li>
          </ul>
          <div className="nav-content active">
            <div className="ul-bg-brand">
              {this.getActiveFilterComponent(this.state.activeFilter)}
            </div>

            <RoomRugFilterSizes
              selectedSizes={this.props.filters.selectedSizes}
              selectHandler={this.props.selectHandler}
			  activeFilter={this.state.activeFilter}
			  texts={this.props.texts}
            />

            <RecommendedRugs
              rugs={this.props.rugs}
              loading={this.props.rugsLoading}
              selectedIds={this.props.selectedIds}
              activeId={this.props.activeId}
              selectHandler={this.props.rugSelectHandler}
              getRugComponent={this.props.getRugComponent}
              hasNext={this.props.rugsHasNext}
              loadRugs={this.props.loadRugs}
              filters={this.props.rugFilters}
              scrollHandler={this.handleScroll}
			  compType={"desktop"}
            />
          </div>
          {/* <button className="btn-down"><i className="arrow" /></button> */}
        </div>
      </>
    );
  }
}
